var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-content filter-card"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Item Level")]),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('div',{ref:"iLevelSlider"})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }